import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsQuery } from '../state/settings/settings.query';

@Injectable({
    providedIn: 'root',
})
export class BrowserSpecialGuard implements CanActivate {
    constructor(private settingsQuery: SettingsQuery, private router: Router) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (
            !this.settingsQuery.showClinicDetails &&
            this.settingsQuery.browser
        ) {
            const fullPathFromRoot = next.pathFromRoot.reduce<string[]>(
                (arr, item) => [
                    ...arr,
                    ...item.url.map((segment) => segment.path),
                ],
                []
            );
            const newUrl = [...fullPathFromRoot.slice(0, -1), 'user-account'];

            /** Si puedo mostrar el tab de details redirijo a details, si no a mi perfil */
            /** Redirigimos con el queryParam de parentSystemKey */
            let parentSystemKeyQueryParams = '';
            if (next.queryParams.parentSystemKey) {
                parentSystemKeyQueryParams =
                    '?parentSystemKey=' + next.queryParams.parentSystemKey;
            }

            return this.router.parseUrl(
                newUrl.join('/') + parentSystemKeyQueryParams
            );
        }
        return true;
    }
}
